"use client";

import { ChakraProvider } from "@chakra-ui/react";

import customTheme from "@/themes/customTheme";

import { ColorModeProvider } from "./color-mode";

export function Provider(props) {
    return (
        <ChakraProvider value={customTheme}>
            <ColorModeProvider {...props} />
        </ChakraProvider>
    );
}
